<template>
  <v-row no-gutters>
    <v-col v-if="!hasBindedStyle" cols="4" class="_pt _pr-">
      <ColorPickerV2 :colorSelected="selectedSection" type="color" title="Cor da fonte" :compact="true" />
    </v-col>

    <v-col v-if="!hasBindedStyle" cols="4" class="_pt _pl-">
      <ColorPickerV2 :colorSelected="selectedSection" type="background-color" title="Cor do fundo" :compact="true"/>
    </v-col>

    <v-col v-if="!hasBindedStyle" cols="4" class="_pt pl-2">
      <TextField 
        v-model="fontSize.buttonBorderRadius"
        label="Borda"
        placeholder="px"
        type="number"
        :minValueForNumber="0"
        @input="updateSize($event, selectedSection, 'border')"
      />
    </v-col>

    <v-col v-if="showField('content')" cols="12" class="_pt _pr-">
      <TextField v-model="selectedSection.caption"/>
    </v-col>

    <!-- <v-col v-if="showField('alignment')" cols="5" class="_pt _pl-">
      <FormAlignment v-model="selectedSection" keyValue="button-alignment"/>
    </v-col> -->

    <v-col v-if="sectionType !== 'speakers' && showField('action')" cols="12" class="_pt">
      <Select
        v-model="destination"
        :icon="getDestinationIcon"
        :items="destinations"
        :showBorder="true"
        @change="changeDestination"
      />
    </v-col>

    <v-col v-if="destination === 'Seção' && sectionType !== 'speakers' && showField('action')" cols="12" class="_pt">
      <Select
        v-model="selectedSection.action"
        placeholder="Escolha a seção destino"
        item-text="title"
        item-value="id"            
        :items="sectionsId"
        :showBorder="true"
      />
    </v-col>

    <v-col v-if="destination === 'Página' && sectionType !== 'speakers' && showField('action')" cols="12" class="_pt">
      <Select
        v-model="selectedSection.action"
        placeholder="Escolha a página destino"
        item-text="name"
        item-value="id"            
        :items="getPages"
        :showBorder="true"
      />
    </v-col>

    <v-col v-if="destination === 'Link Externo' && showField('action')" cols="12" class="_pt">
      <TextField placeholder="https://" v-model="selectedSection.action"/>
    </v-col>
  </v-row>    
</template>

<script>
import { mapGetters } from 'vuex'
import Select from '../../../_v2/ui/Select.vue'
import TextField from '../../../_v2/ui/TextField.vue'
import ColorPickerV2 from '../../../_v2/ui/ColorPickerV2.vue'
import FormAlignment from '../../../_v2/utils/FormAlignment.vue'

export default {
  name: 'Button',
  components: {Select, TextField, ColorPickerV2, FormAlignment},
  props: {
    selectedSection: {type: Object, required: true},
    sectionType: {type: String, required: true},
    sectionsId: {type: Array, required: true},
    hide: {type: Array, default: () => ([])}, // ['alignment', 'content', 'action']     
    hasBindedStyle: {type: Boolean, required: true}
  },

  computed: {
    ...mapGetters(['infos']),

    getDestinationIcon () {
      if (this.destination === 'Seção') return 'fa-solid fa-arrow-up-right-from-square'
      if (this.destination === 'Link Externo') return 'fa-solid fa-link'
      if (this.destination === 'Abrir Checkout') return 'fa-solid fa-cart-shopping'
      if (this.destination === 'Página') return 'fa-solid fa-arrow-up-right-from-square'
    },

    getPages () {
      return this.infos.pages
    }    
  },   

  data: () => ({
    fontSize: { buttonBorderRadius: '' },
    destinations: ["Seção", "Página", "Link Externo", "Abrir Checkout"],
    destination: "Seção"        
  }),

  mounted () {
    this.formatOnInit()
  },      

  methods: {
    formatOnInit() {
      if (this.selectedSection["border-radius"]) {
        this.fontSize.buttonBorderRadius = this.selectedSection["border-radius"].split("px")[0]
      }

      const action = this.selectedSection.action
      if (action) {
        if (action.includes('#')) this.destination = 'Seção'
        else if (action.includes('http') || action.includes('www')) this.destination = 'Link Externo'
        else this.destination = 'Abrir Checkout'
      }
    },

    updateSize(event, type, border) {
      let model = "";
      model = event + "px";
      if (border === "border") type["border-radius"] = model;
      else type["font-size"] = model;
    },

    changeDestination() {
      if (this.destination === "Abrir Checkout") this.selectedSection.action = "Abrir Checkout";
      else this.selectedSection.action = "";
    },

    showField (type) {
      return !this.hide.includes(type)
    }        
  }     
}
</script>